import React, { useEffect } from "react";
import { HiOutlineSparkles } from "react-icons/hi";

import GridBackground from "../../components/Welcome/GridBackground";
import Footer from "../../components/Footer";
import logEvent from "../../amplitude";

// Import founder images
const AbhinavImage = require("../../assets/founders/Abhinav.JPG");
const LuellaImage = require("../../assets/founders/Luella.jpeg");

const Team = () => {
    useEffect(() => {
        logEvent("page_view", {
            page_title: "Team",
            page_location: window.location.href,
            page_path: window.location.pathname,
        });
    }, []);

    const founders = [
        {
            name: "Abhinav Reddy Palle",
            role: "CEO & Co-Founder",
            image: AbhinavImage,
            experience: "Software Engineer at Waymo, Google, Flexport",
            education: "MS Computer Science, UCR",
            linkedin: "https://www.linkedin.com/in/abhinavreddy-palle/",
        },
        {
            name: "Luella Fu",
            role: "CRO & Co-Founder",
            image: LuellaImage,
            experience: "Tenured Professor SFSU • Ex-Meta",
            education: "PhD Statistics USC • MS Yale",
            linkedin: "https://www.linkedin.com/in/luella-fu-9575551b/",
        },
    ];

    return (
        <div className="min-h-screen bg-white">
            {/* Hero Section */}
            <div className="relative overflow-hidden bg-gradient-to-b from-white to-gray-50 -mt-9">
                <GridBackground gridOpacity={0.5} gridSize={40} gridColor="#CBD5E1" />

                <div className="container mx-auto px-6 pt-32 pb-24 relative">
                    <div className="max-w-4xl mx-auto text-center">
                        <div className="mb-8">
                            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gray-100 text-gray-700 text-sm font-medium border border-gray-200">
                                <HiOutlineSparkles className="w-5 h-5" />
                                Meet Our Team
                            </div>
                        </div>

                        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-gray-900 leading-tight mb-6">
                            World-Class AI Team
                        </h1>

                        <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8 leading-relaxed">
                            Engineers from Waymo, Google, and Meta combined with tenured research
                            expertise from USC and Yale.
                        </p>
                    </div>
                </div>
            </div>

            {/* Founders Section */}
            <div className="bg-white py-24">
                <div className="container mx-auto px-6">
                    <div className="grid md:grid-cols-2 gap-16 max-w-5xl mx-auto">
                        {founders.map((founder, index) => (
                            <div key={index} className="text-center">
                                <div className="mb-8">
                                    <img
                                        src={founder.image}
                                        alt={founder.name}
                                        className="w-64 h-64 rounded-full mx-auto object-cover border-4 border-gray-100 shadow-lg"
                                    />
                                </div>
                                <h2 className="text-3xl font-bold text-gray-900 mb-2">
                                    {founder.name}
                                </h2>
                                <div className="text-xl text-gray-600 mb-4">{founder.role}</div>
                                <div className="text-lg text-gray-700 mb-6 leading-relaxed max-w-md mx-auto">
                                    <p className="mb-2">{founder.experience}</p>
                                    <p className="text-gray-600">{founder.education}</p>
                                </div>
                                <a
                                    href={founder.linkedin}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition-colors"
                                >
                                    <svg
                                        className="w-5 h-5"
                                        fill="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                                    </svg>
                                    LinkedIn
                                </a>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* CTA Section */}
            <div className="bg-gray-50">
                <div className="container mx-auto px-6 py-24">
                    <div className="max-w-4xl mx-auto text-center">
                        <h2 className="text-4xl font-bold text-gray-900 mb-6">
                            Ready to Work with Us?
                        </h2>
                        <p className="text-xl text-gray-600 mb-10">
                            Let's discuss how our AI video platform can transform your workflow.
                        </p>
                        <div className="flex flex-col sm:flex-row gap-4 justify-center">
                            <button
                                className="px-8 py-4 bg-gray-900 text-white rounded-lg font-semibold hover:bg-gray-800 transition-colors"
                                onClick={() =>
                                    window.location.assign(
                                        "https://calendly.com/abhinav-vw1y/30min"
                                    )
                                }
                            >
                                Schedule a Meeting
                            </button>
                            <button
                                className="px-8 py-4 bg-white text-gray-900 border border-gray-300 rounded-lg font-semibold hover:bg-gray-50 transition-colors"
                                onClick={() => (window.location.href = "/signup")}
                            >
                                Try QuickSight
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default Team;
